<template>
    <div class="view" :style="{paddingTop:barh(0)}">
        <div class="content">
          <div v-if="step==1" style="width: 100%; display: flex;align-items: center;justify-content: center">
            <van-loading color="#0094ff" type="spinner" size="50"/>
          </div>
            <!-- <div v-if="step==1" style="">
              <div>
                <img style="width: 100%;" src="../../assets/img/u1485.png" />
              </div>
              <div style="margin: 50px 0;">
                <p class="tip-text">首次使用人脸核验身份，需要先录入面部数据。为了能够成功录入你的面部特征，请保持面部无遮挡，确保摄像头清洁，周围环光线适宜。
                </p>
                <p style="color: #FF0000;">
                  注意：人脸录入后，不可修改，请认真操作，谨慎对待！！！
                </p>
              </div>
              <div>
                <van-button size="large" type="info" @click="playVideo">我明白了，下一步</van-button>
              </div>
            </div>
            
            <div v-show="step==2" class="face-capture" id="face-capture">
                <img src="../../assets/img/video-cover.png" alt="cover" class="img-cover"/>
                <div class="control-container face-capture">
                    <div class="title">{{scanTip}}</div>
                    <Icon class="close" @click="goBack" name="clear" />
                    <canvas ref="refCanvas" :width="screenSize.width" :height="screenSize.height"></canvas>
                </div>
            </div>
            
            <div v-if="step==3" class="face-capture">
              <img src="../../assets/img/video-cover.png" alt="cover" class="img-cover"/>
              <div class="title" style="width: 80%;z-index: 3;">人脸识别中…</div>
              <img style="width: 100%;margin: 0;padding: 0;border: 0;display: block;" v-show="imgUrl" :src="imgUrl"/>
            </div> -->
            
            <div v-if="step==4" style="width: 100%;">
              <van-button size="large" type="info" @click="playVideo(2)" style="margin-bottom: 1rem;">重新录入</van-button>
              <van-button size="large" type="info" @click="toback">稍后再试</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon } from 'vant';
// import tracking from '@/assets/js/tracking-min.js'
// import '@/assets/js/face-min.js'
import application from '@api/application';
import common from '@/api/common'
import { ImgBaseURL } from '@http/config';
import CSCEC from '@/core/cscec/cscec'
export default {
    name:'FaceCamera',
    components: { Icon },
    data() {
        return {
          uploadUrl: ImgBaseURL + '/cscec-common-business/files/upload',
          token: this.$store.state.user.token,
          step: 1,
          screenSize: {width: window.screen.width, height: window.screen.height},
          URL: null,
          streamIns: null,        // 视频流
          showContainer: false,   // 显示
          tracker: null,
          tipFlag: false,         // 提示用户已经检测到
          flag: false,            // 判断是否已经拍照
          context: null,          // canvas上下文
          profile: [],            // 轮廓
          removePhotoID: null,    // 停止转换图片
          scanTip: '人脸识别中...',// 提示文字
          imgUrl: ''              ,// base64格式图片
          time: null,
          bitmap: null
        }
    },
    created() {
    },
    computed: {
      isRegistered() {
        return this.$route.query.isRegistered
      }
    },
    mounted() {
      if(this.isRegistered) {
        console.log('isRegistered')
        this.playVideo(1)
      } else {
        this.playVideo(2)
      }
    },
    methods: {
      checkPermissionPos() {
        let permissionStatusOk = false;
        let permission = plus.navigator.checkPermission('CAMERA');
        switch(permission){
            case 'authorized':
              // 程序已被用户授权使用此权限
              permissionStatusOk = true;
              console.log('已开启相机权限');
            break;
            case 'denied':
              //表示程序已被用户拒绝使用此权限。如果是拒绝的就再次提示用户打开确认提示框  
              //如果有该权限但是没有打开不进行操作还是会去申请或手动打开  
              // console.log('已关闭' + permissionName + '权限')  
              // errorCallBack('已关闭' + permissionName + '权限');  
              console.log('已关闭相机权限');
            break;
            case 'undetermined':
              // 表示程序未确定是否可使用此权限，此时调用对应的API时系统会弹出提示框让用户确认
              // this.requestPermissions(androidPermission, permissionName, successCallBack, errorCallBack)  
              // errorCallBack('未确定' + permissionName + '权限');  
              console.log('未确定相机权限');
            break;
            case 'notdeny':
              // 表示程序未被用户拒绝使用此权限（与denied相反，可能是"authorized"或者"undetermined"）
              break;
            case 'unknown':
              // 表示程序未知此权限状态（系统存在权限管理但无法查询）
              console.log('无法查询相机权限');
            break;
            case 'unsupported':
              // 表示程序不支持此权限
              console.log('不支持相机权限');
            break;
            default:
              console.log('不支持相机权限');
            break;
        	}
          return permissionStatusOk
      },
      requestPermissions(callback) {
        let permissionStatusOk = this.checkPermissionPos()
        if (!permissionStatusOk) {
          if (plus.os.name == 'Android') {
            plus.android.requestPermissions(['android.permission.CAMERA'], (e) => {
              if (e.deniedAlways.length > 0) {	//权限被永久拒绝
                // 弹出提示框解释为何需要定位权限，引导用户打开设置页面开启
                
                console.log('Always Denied!!! '+e.deniedAlways.toString());
                callback(false)
              }
              if (e.deniedPresent.length > 0){	//权限被临时拒绝
                // 弹出提示框解释为何需要定位权限，可再次调用plus.android.requestPermissions申请权限
                console.log('Present Denied!!! '+e.deniedPresent.toString());
                callback(false)
              }
              if (e.granted.length > 0) {	//权限被允许
                  //调用依赖获取定位权限的代码
                console.log('Granted!!! '+e.granted.toString());
                callback(true)
              }
            }, (e) => {
                console.log('Request Permissions error:'+JSON.stringify(e));
            });
          } else if (plus.os.name == 'iOS') {
            let permission = plus.navigator.checkPermission('CAMERA');
            if (permission == 'undetermined') {
              callback(true)
            } else {
              plus.nativeUI.confirm('摄像头权限没有开启，是否去开启？', (e) => {
                  //取消  
                  if (e.index == 0) {  
                      callback(false)
                  } else if (e.index == 1) {  
                      //确认，打开当前应用权限设置页面  
                      var UIApplication = plus.ios.import('UIApplication');  
                      var application2 = UIApplication.sharedApplication();  
                      var NSURL2 = plus.ios.import('NSURL');  
                      // var setting2 = NSURL2.URLWithString("prefs:root=LOCATION_SERVICES");                             
                      var setting2 = NSURL2.URLWithString('app-settings:');  
                      application2.openURL(setting2);  

                      plus.ios.deleteObject(setting2);  
                      plus.ios.deleteObject(NSURL2);  
                      plus.ios.deleteObject(application2)  
                  }  
              }, '温馨提示', ['取消', '确认'])  
            }
          }
        } else {
          callback(true)
        }
      },
      playVideo(type = 2) {
        this.step=1
        CSCEC.openCameraPreview({
          success: this.trankSuccess,
          fail: this.trankErr,
          type
        })
        // console.time('permission')
        // this.requestPermissions((res) => {
        //   if (res) {
        //     console.timeEnd('permission')
        //     console.time('openCameraPreview')
        //     CSCEC.openCameraPreview({
        //       success: this.trankSuccess,
        //       fail: this.trankErr
        //     })
        //   } else {
        //     plus.nativeUI.alert("人脸识会调用您的摄像头，请开启摄像头权限后重试",(e) => {
        //       var i = e.index;
        //       if(i < 0){
        //         console.log( "按\"返回\"键关闭提示框！" );
        //       }else{
        //         console.log( "提示框已关闭！" );	
        //       }
        //     }, "温馨提示", "关闭");
        //   }
        // })
      },
      trankSuccess(optstr) {
        try {
          let opt = JSON.parse(optstr)
          // alert(opt.path)
          // plus.io.getImageInfo({
          //   src: opt.path,
          //   success: (even) => {
          //     // alert(even.path)
          //     // this.imgUrl = even.path;
          //     this.compare(even.path)
          //   },
          //   fail: (error) => {
          //     alert(error.message)
          //   }
          // });
          this.compare(opt.path)
        } catch(err) {
          alert(err)
        }
      },
      trankErr(err) {
        if (this.isRegistered) {
          this.$toast('人脸采集失败！')
          setTimeout(() => {
            this.toback()
          }, 2000)
        } else {
          this.step = 4
          this.close()
        }
      },
      // /将BASE 64保存为文件/
      saveHeadImgFile(uid, base64, quality, cback){
        this.bitmap = new plus.nativeObj.Bitmap("test");
        // 从本地加载Bitmap图片
        this.bitmap.loadBase64Data(base64, () => {
          // console.log('加载图片成功');
          // 保存图片到手机
          this.bitmap.save( "_doc/"+uid+".png",{ overwrite:true, quality: quality },(event) => {
          console.log('保存图片成功：'+JSON.stringify(event));
          cback(event.target);
          }, (e) => {
            console.log('保存图片失败：'+JSON.stringify(e));
          });
        }, (e) => {
          console.log('加载图片失败：'+JSON.stringify(e));
        });
      },
      // 销毁原生bitmap对象，释放内存
      recycle() {
        if (this.bitmap && this.bitmap.recycle) {
          this.bitmap.recycle();
          this.bitmap.clear();
          this.bitmap = null
        }
      },
      // 文件上传
      upload(url, dirURL, type, fileId, callback) {
        let task = plus.uploader.createUpload(url, {
            method: 'POST'
        }, (t, status) => {
            // 上传完成
            if (status == 200) {
                let res = JSON.parse(t.responseText);
                console.log('upload success:'+t.responseText)
                callback(res)
            } else {
              let msg = type == 'register' ? '注册失败！' : '登录失败！'
              callback({
                code: 500,
                data: msg,
                msg
              })
                // this.$toast(msg+ status);
                // if (type=='register') {
                //   this.step = 4
                // } else {
                //   this.toback()
                // }
            }
        });
        task.setRequestHeader('Authorization', 'Bearer ' + this.token)
        task.setRequestHeader('token', this.token)
        task.addFile(dirURL, { key: 'file'});
        if (type=='upload') {
          task.addData("businessCode", "FACE06");
          task.addData("isEnable", true);
          task.addData("desc", "");
        } else if (type=='register') {
          task.addData("userId", this.$store.state.user.userInfo.userId);
          task.addData("fileId", fileId);
        } else {
          task.addData("userId", this.$store.state.user.userInfo.userId);
        }
        task.start();
      },
      register(url) {
        this.upload(this.uploadUrl, url, 'upload', null, (res) => {
          if (res.code == 200) {
            let fileId = res.data.commonId
            this.upload(ImgBaseURL + '/face-producer-server/faceInfo/register', url, 'register', fileId, (resp) => {
              if (resp.code == 0) {
                this.$toast({
                  duration: 2000,
                  message: resp.data || '注册成功！'
                })
                setTimeout(() => {
                  this.toback()
                }, 2000)
              } else {
                this.$toast({
                  duration: 5000,
                  message: resp.msg || '注册失败！'
                })
                this.step = 4
              }
            })
          } else {
            this.$toast('上传失败！');
            this.step = 4
          }
        })
      },
      login(url) {
        this.upload(ImgBaseURL + '/face-producer-server/faceInfo/login', url, 'login', null, (res) => {
          if (res.code == 0) {
            this.$toast(res.data || '登录成功')
            this.$router.replace({
                path:"/project/leaders/addrecordDetails",
                query:{
                    type:'add',
                    projectId:this.$store.state.project.projectId
                }
            })
          } else {
            this.$toast({
              duration: 5000,
              message: res.msg || '登录失败'
            })
            setTimeout(() => {
              this.toback()
            }, 5000)
          }
        })
      },
      compare(url) {
          // let blob = this.getBlobBydataURI(url, 'image/png')
          console.log('getblob')
          // TODO 得到文件后进行人脸识别
          if (this.isRegistered) {
            this.login(url)
          } else {
            this.register(url)
          }
      },
      // 关闭并清理资源
      close() {
      },
      goBack() {
        console.log(111)
        this.close()
        this.toback()
      }
    }
}
</script>

<style lang="scss" scoped>
.view {
    .content {
      padding: 0 1.6rem;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      .tip-text {
        font-family: '华文楷体';
        font-weight: 400;
        font-style: normal;
        font-size: 2rem;
        color: #7F7F7F;
      }
      .face-capture {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex: 1;
          width: 100%;
      }

      .face-capture video, .face-capture canvas {
          position: fixed;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 2;
          background-repeat: no-repeat;
          background-size: 100% 100%;
      }

      .face-capture canvas {
          z-index: 2;
      }

      .face-capture .img-cover {
          position: fixed;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 2;
          background-repeat: no-repeat;
          background-size: 100% 100%;
      }

      .face-capture .rect {
          border: 2px solid #0aeb08;
          position: fixed;
          z-index: 3;
      }

      .face-capture .control-container {
          margin-top: 10rem;
          position: relative;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 4;
          background-repeat: no-repeat;
          background-size: 100% 100%;
      }

      .face-capture .title {
          text-align: center;
          color: white;
          margin: 1.6rem auto;
          font-size: 1.6rem;
          background: rgb(0 0 0 / 30%);
          width: 100%;
          height: 40px;
          line-height: 40px;
          position: absolute;
          bottom: 10rem;
      }

      .face-capture .close {
        position: absolute;
        bottom: 20rem;
        font-size: 3.6rem;
        color: #fff;
        z-index: 3;
      }
    }
}
</style>
